module.exports = __webpack_public_path__ + "static/media/2.16.2de7a5a1.png";